<template>
    <div style="display:inline-flex">
        <a-range-picker ref="cTimeRange" :disabled-date="disabledDate"
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />
        
            <a-select v-model="timeCurrent" style="width: 80px;margin-left:20px;" @change="handleTypeChange">
                <a-select-option v-for="item in timeValue" :key="item.key" :value="item.name">
                    {{item.name}}
                </a-select-option>
            </a-select>

            <!-- <a-button type="link" @click="getRange(timeValue[4])">今天</a-button> -->
    </div>

</template>

<script>
import moment from 'moment';

const timeValue = [
    {
        key:7,
        name:'1分钟'
    },
    {
        key:8,
        name:'5分钟'
    },
    {
        key:10,
        name:'15分钟'
    },
    {
        key:9,
        name:'1小时'
    },
    {
        key:11,
        name:'1天'
    },
]

export default {
    model:{
        prop:'selectedTimeRange',
        event:'change'
    },
    props:{
        selectedTimeRange:String
    },
    data() {
        return {
            dateFormat:"YYYY-MM-DD HH:mm",
            timeRange:undefined,
            timeValue,
            timeCurrent:'1天'
        }
    },
    methods: {
        onChange(v,t){
            let timeStr = t[0] + "~" + t[1] + "~" + this.timeCurrent;
            this.handleTimeChange(timeStr);

        },

        handleTypeChange(v){
            let targetItem = this.timeValue.filter((n) => { return n.name == v });
            this.getRange(targetItem[0])
        },

        disabledDate(current) {
            // 日志库保存日期默认14天，可选择19天以内时间
            return current && current < moment().subtract(14, 'days');
        },

        getRange(titem){
            //默认一天时内
            let result = this.G.getRecentDate(titem.key)
            let sTime = this.fDate(result.start_time);
            let eTime = this.fDate(result.end_time);
            let timeStr = sTime + "~" + eTime + "~" + titem.name;
            this.handleTimeChange(timeStr);
            this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]

        },
        handleTimeChange(timeStr){
            this.$emit("change",timeStr)
        },
        setTime(t){
            this.timeRange = t
        },
        fDate(t){
            return (new Date(t)).Format("yyyy-MM-dd hh:mm");
        }
    },
    mounted() {
        const {query} = this.$route;
        if(query.timeRange){
            let sTime = query.timeRange.split('~')[0];
            let eTime = query.timeRange.split('~')[1];
            this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)];
            this.handleTimeChange(query.timeRange);
        }
        else if(query.st && query.et){
            let query_sTime = this.fDate(parseInt(query.st) * 1000);
            let query_eTime = this.fDate(parseInt(query.et) * 1000);
            let timeStr = query_sTime + "~" + query_eTime + "~" + timeValue[4].name;
            this.timeRange = [moment(query_sTime, this.dateFormat), moment(query_eTime, this.dateFormat)];
            this.handleTimeChange(timeStr);
        }
        else{
            this.getRange(timeValue[4]);
        }

        
    },
    

}
</script>

<style scoped>
    .active{
        color: #fff;
        background-color: #1890ff;
        border-color: #1890ff;
        text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
        -webkit-box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
        box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
    }
</style>
